import TimeSelector from './time-selector'

export default TimeSelector
